import { axios } from '@/lib/axios';

import { BuyCryptoInput } from '../components/BuyCryptoForm';

export const buyCrypto = async (payload: BuyCryptoInput) => {
  const resp = await axios.post('/crypto/buy', payload);

  return resp.data;
};
